import { type ForwardedRef, forwardRef } from 'react'

import { type ApplicationScope } from '@/apis/accounts/interfaces'

import { PRODUCT_PAGE_TABS } from '@/constants'

import Section from '../Section'
import { Scopes } from './Scopes/Scopes'
import { TermsBanner } from './TermsBanner'

interface Props {
  name: string
  privacyPolicyUrl?: string
  termsAndConditionsUrl?: string
  scopes: ApplicationScope[]
  innerRef: ForwardedRef<HTMLElement>
}

const AppTerms = ({
  name,
  privacyPolicyUrl,
  termsAndConditionsUrl,
  scopes,
  innerRef,
}: Props) => {
  const hasScopes = !!scopes.length

  return (
    <Section id={PRODUCT_PAGE_TABS.APP_TERMS} title="App Terms" ref={innerRef}>
      <TermsBanner
        privacyPolicyUrl={privacyPolicyUrl}
        termsAndConditionsUrl={termsAndConditionsUrl}
        hasScopes={hasScopes}
      />
      <Scopes name={name} scopes={scopes} />
    </Section>
  )
}

export default forwardRef((props: Props, ref: ForwardedRef<HTMLElement>) => (
  <AppTerms {...props} innerRef={ref} />
))
